import AbsList from "../components/AbsList";
import ListItem from './ListItem';

export default class List extends AbsList{

    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);
        
        this.listApiPath = `/search/spells`;
        this.ListItemCon = ListItem;
        
        const watchQ = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQ( this.stack.bind(this) ) );
        
        const watchG = this.watch(this.store.getState, 'grades', this.isEqual);
        this.store.subscribe( watchG( this.stack.bind(this) ) );
        
        const watchLearn = this.watch(this.store.getState, 'learn', this.isEqual);
        this.store.subscribe( watchLearn( this.stack.bind(this) ) );
        
        const watchSpelltype = this.watch(this.store.getState, 'spelltype', this.isEqual);
        this.store.subscribe( watchSpelltype( this.stack.bind(this) ) );
        
        const watchElemental = this.watch(this.store.getState, 'elemental', this.isEqual);
        this.store.subscribe( watchElemental( this.stack.bind(this) ) );
        
        const watchF = this.watch(this.store.getState, 'favorite', this.isEqual);
        this.store.subscribe( watchF( this.stack.bind(this) ) );
        
        const watchP = this.watch(this.store.getState, 'page', this.isEqual);
        this.store.subscribe( watchP( this.stack.bind(this) ) );
        
        const watchParams = this.watch(this.store.getState, 'isParamsLoaded', this.isEqual);
        this.store.subscribe( watchParams( this.loadList.bind(this) ) );
    }

    getParams(){
        let state = this.store.getState(); 

        let params = {
            locale: state.config.locale,
            page: state.page,
            size: this.pageSize
        };
        this.makeParams(params, 'keyword', state.query );
        this.makeParams(params, 'gradeIds', state.grades);
        this.makeParams(params, 'learnLimitClassIds', state.learn);
        this.makeParams(params, 'spellTypes', state.spelltype);
        this.makeParams(params, 'elementalTypeIds', state.elemental);
        this.makeParams(params, 'favorite', state.favorite);

        return params;
    }

} // end of class